import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';
import { pick, prop } from 'ramda';
import getDevice from 'device/helpers';
import { useLocation } from 'react-router-dom';
import { getUserAgent } from 'js/utils/device.util';
import { getLocationParam } from 'js/utils/url.util';

export const useCommonProperties = () => {
    const { casinoName, clientSkin, clientType } =
        useAppSelector(pick(['casinoName', 'clientSkin', 'clientType', 'errorLevel']));
    const { lang, currencyCode } = useUserSelector(pick(['lang', 'isLoggedIn', 'userName', 'currencyCode']));
    const ua = getUserAgent();
    const { clientPlatform, deliveryPlatform } = useDeviceSelector(prop('clientPlatform', 'deliveryPlatform'));
    const gameCode = getLocationParam('game');

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const preview = searchParams.get('preview');

    return {
        'super.clientSkin': clientSkin,
        'super.casinoName': casinoName,
        'super.clientVersion': '2.0.0',
        'super.biVersion': '0', // configurable
        'super.clientLanguageCode': lang,
        'super.device': getDevice().os === 'ios' ? getDevice().name : undefined,
        'super.device.name': getDevice().name,
        'super.device.operatingSystem': getDevice().os,
        'super.device.browser': getDevice().browserName,
        'super.device.browserVersion': getDevice().browserVersion,
        'super.device.userAgent': ua,
        'super.device.orientation': getDevice().orientation,
        'super.currencyCode': currencyCode,
        'super.product': 'H2S',
        'super.clientPlatform': clientPlatform,
        'super.clientType': clientType,
        'super.deliveryPlatform': deliveryPlatform,
        'game.mainLaunchAlias': gameCode,
        clientWidth: document.body.clientWidth,
        clientHeight: document.body.clientHeight,
        'super.preview': Boolean(preview),
        application: 'Hub2Shared',
        engagementEventType: 'Leaderboard'
    };
};
